
export const STICK="STICK"
export const SIDEBARTOGEL="SIDEBARTOGEL"